/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from 'react';
import { OffersMultiplierProps } from './OffersMultiplier.types';
import { Eyebrow, Heading, Types } from '@marriott/mi-ui-library';
import { OffersMultiplierMock } from './__mock__/OffersMultiplier.mock';
import clsx from 'clsx';
import { PointsCard } from '@marriott/mi-cobrand-components';
import { useGetBreakpoint } from '../../utils/CommonUtils';

export const OffersMultiplierWrapper: FC<OffersMultiplierProps> = props => {
  const { isAuthorMode, offersData } = props;

  const multiplierData = OffersMultiplierMock?.merchandisingOffer?.singleCard?.multiplier; //replace with productspecificresponse
  const isMobileViewPort = useGetBreakpoint() === 'mobile';
  console.log(isAuthorMode, offersData, 'OffersMultiplierProps');
  return (
    <div className="offermultiplier-container">
      <div className="offermultiplier-wrapper">
        <div className="multiplier-center">
          <Eyebrow text={multiplierData?.eyebrow} customClass={clsx('mb-2 text-center')} />
          <Heading
            titleText={multiplierData?.title}
            variation={Types.headingType.title}
            fontSize={Types.size.medium}
            customClass={'multiplier-title text-center mb-0'}
          />
          {multiplierData?.points?.length > 0 &&
            multiplierData?.points?.map(point => {
              return (
                <div className="points-card-wrapper">
                  <PointsCard
                    isOnSpend={!isMobileViewPort}
                    number={point?.text}
                    content={point?.description}
                    variationType="default"
                    cardType=""
                    pointsForCarddetails={false}
                    styleClass="offers-pointscard"
                  />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
